import { render, staticRenderFns } from "./BasicPagination.vue?vue&type=template&id=6b65bcf8"
import script from "./BasicPagination.vue?vue&type=script&lang=js"
export * from "./BasicPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports